import type { MaskedOptions } from 'imask';
import { Locale } from '@cars4ever/public-ui';

import { LOCALE } from '@digital-dealer/environments';

interface ILocaleMask {
  [key: string]: Record<string, MaskedOptions['mask'] | undefined>;
}

const localeMasksMap: ILocaleMask = {
  zip: {
    [Locale.DK]: '0000',
    [Locale.SE]: '000 00',
  },
  phone: {
    [Locale.DK]: '+45 00 00 00 00',
    [Locale.SE]: undefined,
  },
  plateNumber: {
    [Locale.DK]: 'aa 00 000',
    [Locale.SE]: 'aa 000',
  },
  plateNumberCustom: {
    [Locale.DK]: /^[a-zA-Z0-9]{0,7}$/,
    [Locale.SE]: /^[a-zA-Z0-9]{0,8}$/,
  },
  crv: {
    [Locale.DK]: '00000000',
    [Locale.SE]: '000000-0000',
  },
};

export const zipMask = localeMasksMap.zip[LOCALE];

export const phoneMask = localeMasksMap.phone[LOCALE];

export const cprMask = '000000-0000';

export const cvrMask = localeMasksMap.crv[LOCALE];

export const plateNumberMask: MaskedOptions[] = [
  { mask: (localeMasksMap.plateNumber[LOCALE] || '') as string },
  { mask: (localeMasksMap.plateNumberCustom[LOCALE] || '') as string },
];

